import React, { Component } from 'react'

export default class ItemCardNoPrices extends Component {

    selectItem(item) {
        const Padre = this.props.Padre;
        Padre.setState({ selectedItem: item });
    }

    render() {
        return (
            <div
                onClick={() => this.selectItem(this.props.objectProd)}
                style={{
                    background: '#ffffff',
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    padding: '12px',
                    marginBottom: '10px',
                    cursor: 'pointer',
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center',
                    transition: 'border-color 0.18s, box-shadow 0.18s',
                }}
                onMouseEnter={e => {
                    e.currentTarget.style.borderColor = '#2563EB';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(37,99,235,0.10)';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.borderColor = '#E2E8F0';
                    e.currentTarget.style.boxShadow = 'none';
                }}
            >
                {/* Product image */}
                <img
                    key={this.props.itemURLImage}
                    src={this.props.itemURLImage || './assets/notavailable.png'}
                    alt={this.props.Description}
                    style={{
                        width: '84px',
                        height: '84px',
                        objectFit: 'contain',
                        borderRadius: '8px',
                        background: '#F8FAFC',
                        flexShrink: 0,
                        border: '1px solid #F1F5F9',
                        padding: '4px',
                    }}
                />

                {/* Info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                    {/* Badges */}
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '6px' }}>
                        <span style={{
                            background: 'rgba(37,99,235,0.08)',
                            color: '#1e40af',
                            border: '1px solid #BFDBFE',
                            borderRadius: '6px',
                            padding: '2px 8px',
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            letterSpacing: '0.3px',
                        }}>
                            {this.props.ItemCode}
                        </span>
                        <span style={{
                            background: 'rgba(16,185,129,0.08)',
                            color: '#065F46',
                            border: '1px solid #A7F3D0',
                            borderRadius: '6px',
                            padding: '2px 8px',
                            fontSize: '0.72rem',
                            fontWeight: 700,
                        }}>
                            On Hand: {this.props.OnHand ? this.props.OnHand : 0}
                        </span>
                    </div>

                    {/* Description */}
                    <p style={{
                        margin: 0,
                        fontSize: '0.875rem',
                        color: '#0F172A',
                        fontWeight: 500,
                        lineHeight: 1.4,
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}>
                        {this.props.Description}
                    </p>
                </div>
            </div>
        );
    }
}
